document.addEventListener("DOMContentLoaded", () => {
  // Ensure GSAP and ScrollTrigger are loaded
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  // Check for mobile or reduced motion preference
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const disableHeavyAnimations = isMobile || prefersReducedMotion;

  // Hero Text Preparation (Split words for elegant animation)
  const heroTitles = document.querySelectorAll('.mockup-hero__title');
  heroTitles.forEach(heroTitle => {
    const lines = heroTitle.innerHTML.split(/<br\s*\/?>/i);
    const wrappedLines = lines.map(line => {
      return line.split(' ').map(word => {
        if (!word.trim()) return word;
        return `<span style="display:inline-block; overflow:hidden; vertical-align:top; padding-right:0.2em;"><span class="gs-hero-word-inner" style="display:inline-block; transform-origin: left bottom;">${word}</span></span>`;
      }).join('');
    });
    heroTitle.innerHTML = wrappedLines.join('<br>');
  });

  function playHeroAnimation() {
    const heroTl = gsap.timeline();
    // Only animate the first slide initially
    const firstSlide = document.querySelector('.hero-slide');
    if (!firstSlide) return;

    const words = firstSlide.querySelectorAll('.gs-hero-word-inner');
    if (words.length > 0) {
      if (disableHeavyAnimations) {
        gsap.to(words, { y: '0%', opacity: 1, duration: 0.5 });
      } else {
        heroTl.fromTo(words, 
          { y: '120%', rotateZ: 5, opacity: 0 },
          { y: '0%', rotateZ: 0, opacity: 1, duration: 1.2, stagger: 0.05, ease: "power4.out" }
        );
      }
    }
    const sub = firstSlide.querySelector('.gs-hero-subtitle');
    if (sub) {
      if (disableHeavyAnimations) {
         gsap.to(sub, { y: 0, opacity: 1, filter: 'blur(0px)', duration: 0.5 });
      } else {
        heroTl.fromTo(sub, 
          { y: 30, opacity: 0, filter: 'blur(8px)' },
          { y: 0, opacity: 1, filter: 'blur(0px)', duration: 1.2, ease: "power3.out" },
          "-=0.9"
        );
      }
    }
    const pop = firstSlide.querySelector('.gs-hero-pop');
    if (pop) {
      if (disableHeavyAnimations) {
         gsap.to(pop, { scale: 1, opacity: 1, duration: 0.5 });
      } else {
        heroTl.fromTo(pop, 
          { scale: 0.85, opacity: 0 },
          { scale: 1, opacity: 1, duration: 1.5, ease: "elastic.out(1, 0.6)" },
          "-=1.0"
        );
      }
    }
  }

  // 0. Trigger Hero Immediately
  playHeroAnimation();

  // Initialize Lenis Smooth Scroll (Disable on mobile to prevent jank)
  if (typeof Lenis !== 'undefined' && !disableHeavyAnimations) {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  }

  // 1. Hero Fullscreen Carousel & Parallax
  const heroSection = document.querySelector('.mockup-hero');
  if (heroSection) {
    const slides = gsap.utils.toArray('.hero-slide');
    if (slides.length > 1) {
      // Setup initial state
      slides.forEach((slide, i) => {
        if (i === 0) {
          gsap.set(slide, { opacity: 1, zIndex: slides.length });
        } else {
          gsap.set(slide, { opacity: 0, zIndex: slides.length - i });
        }
      });

      // Auto-Rotate Timeline (Crossfade)
      let currentSlideIndex = 0;
      setInterval(() => {
        const nextSlideIndex = (currentSlideIndex + 1) % slides.length;
        
        const currentSlide = slides[currentSlideIndex];
        const nextSlide = slides[nextSlideIndex];
        
        const currentWords = currentSlide.querySelectorAll('.gs-hero-word-inner');
        const currentSub = currentSlide.querySelector('.gs-hero-subtitle');
        const currentPop = currentSlide.querySelector('.gs-hero-pop');
        
        const nextWords = nextSlide.querySelectorAll('.gs-hero-word-inner');
        const nextSub = nextSlide.querySelector('.gs-hero-subtitle');
        const nextPop = nextSlide.querySelector('.gs-hero-pop');

        if (disableHeavyAnimations) {
           gsap.to(currentSlide, { opacity: 0, zIndex: 0, duration: 1 });
           gsap.to(nextSlide, { opacity: 1, zIndex: slides.length, duration: 1 });
           gsap.set(nextWords, { y: '0%', opacity: 1 });
           if(nextSub) gsap.set(nextSub, { y: 0, opacity: 1, filter: 'blur(0px)' });
           if(nextPop) gsap.set(nextPop, { scale: 1, opacity: 1 });
        } else {
          // Transition out current slide elements
          if (currentWords.length > 0) gsap.to(currentWords, { y: '-120%', opacity: 0, duration: 0.8, ease: "power2.in" });
          if (currentSub) gsap.to(currentSub, { y: -30, opacity: 0, filter: 'blur(8px)', duration: 0.8, ease: "power2.in" });
          if (currentPop) gsap.to(currentPop, { scale: 0.85, opacity: 0, duration: 0.8, ease: "power2.in" });

          // Transition in next slide elements
          if (nextWords.length > 0) gsap.fromTo(nextWords, { y: '120%', rotateZ: 5, opacity: 0 }, { y: '0%', rotateZ: 0, opacity: 1, duration: 1.2, stagger: 0.05, ease: "power4.out", delay: 0.5 });
          if (nextSub) gsap.fromTo(nextSub, { y: 30, opacity: 0, filter: 'blur(8px)' }, { y: 0, opacity: 1, filter: 'blur(0px)', duration: 1.2, ease: "power3.out", delay: 0.7 });
          if (nextPop) gsap.fromTo(nextPop, { scale: 0.85, opacity: 0 }, { scale: 1, opacity: 1, duration: 1.5, ease: "elastic.out(1, 0.6)", delay: 0.8 });

          gsap.to(currentSlide, { opacity: 0, zIndex: 0, duration: 1.5, ease: "power2.inOut" });
          gsap.to(nextSlide, { opacity: 1, zIndex: slides.length, duration: 1.5, ease: "power2.inOut" });
        }
        
        currentSlideIndex = nextSlideIndex;
      }, 5000); // 5 seconds interval
      
      // Parallax Scroll Animation for all slide images
      if (!disableHeavyAnimations) {
        slides.forEach((slide) => {
          const img = slide.querySelector('img, svg');
          if (img) {
            gsap.fromTo(img, { scale: 1 }, {
                scale: 1.15,
                ease: "none",
                scrollTrigger: {
                    trigger: heroSection,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
          }
        });
      }
    }
  }

  // 2. Global Scroll Reveals for Sections
  const sections = document.querySelectorAll('.gs-section');
  sections.forEach((section) => {
    const reveals = section.querySelectorAll('.gs-reveal');
    if (reveals.length > 0 && !disableHeavyAnimations) {
      gsap.fromTo(reveals, 
        { y: 20, opacity: 0.8 },
        {
          y: 0, opacity: 1, duration: 0.8, stagger: 0.1, ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 95%",
            toggleActions: "play none none none"
          }
        }
      );
    }
  });

  // 3. Infinite Interactive Marquee (Trust Banner)
  const marqueeTrack = document.querySelector('.mockup-marquee__track');
  if (marqueeTrack) {
    marqueeTrack.style.animation = 'none';
    const content = document.querySelector('.mockup-marquee__content');
    if (content) {
      marqueeTrack.appendChild(content.cloneNode(true));
      const marqueeWidth = content.offsetWidth;
      let tl = gsap.to('.mockup-marquee__track', {
        x: () => `-=${marqueeWidth}`,
        ease: "none",
        duration: 32,
        repeat: -1,
        modifiers: { x: gsap.utils.unitize(x => parseFloat(x) % marqueeWidth) }
      });
      ScrollTrigger.create({
        onUpdate: (self) => {
          let velocity = Math.abs(self.getVelocity());
          if(velocity > 0) gsap.to(tl, {timeScale: 1 + (velocity / 500), duration: 0.5, overwrite: true});
          else gsap.to(tl, {timeScale: 1, duration: 1, overwrite: true});
        }
      });
    }
  }

  // 8. Spotlight Dashboard Interaction
  const spotlightTabs = document.querySelectorAll('.spotlight-tab');
  const spotlightData = {
    ratio: {
      standard: { tag: '90%+ Wheat', val: '90%+ Mass Wheat', desc: 'Commercial multigrain is mostly mass-produced wheat with minimal millet sprinkling.', badge: '❌ Hidden Ratios & Sluggish Gut' },
      grainary: { tag: '55% Active Blend', val: '55% Real Multigrain', desc: '45% active ancient millets & supergrains (Jowar, Ragi, Bajra, Oats, Besan) for honest nutrient density.', badge: '✓ Certified Clean & Light' }
    },
    fiber: {
      standard: { tag: 'Stripped Bran', val: 'Stripped Bran Fiber', desc: 'High-speed industrial milling strips bran and soluble fiber, causing heaviness and digestive bloat.', badge: '❌ Stripped Fiber & Heavy Gut' },
      grainary: { tag: 'Psyllium Prebiotic', val: 'Enriched Psyllium Husk', desc: 'Natural psyllium husk soluble fiber retains hydration for remarkably soft rotis and comfortable digestion.', badge: '✓ 100% Digestive Comfort' }
    },
    freshness: {
      standard: { tag: '3-6 Mo Aged', val: 'Warehouse Aged Flours', desc: 'Stored in mass distribution godowns for months with artificial anti-caking chemicals and bleaches.', badge: '❌ Stored Grains & Additives' },
      grainary: { tag: 'Fresh Small Batch', val: 'Fresh Cold Stone-Ground', desc: 'Milled to order in food-grade stainless steel facilities. 100% inspected grains with zero warehouse delay.', badge: '✓ Inspected & Freshly Milled' }
    },
    glucose: {
      standard: { tag: 'Fast Spike', val: 'High Glycemic Load', desc: 'Refined high-starch composition triggers rapid blood glucose surges followed by afternoon energy crashes.', badge: '❌ Sugar Spikes & Sluggish Energy' },
      grainary: { tag: 'Low GI Certified', val: 'Slow Sustained Energy', desc: 'Formulated with barley, oats, and fenugreek to release glucose slowly for steady all-day vitality.', badge: '✓ Metabolic Balance & Steady Energy' }
    }
  };

  if (spotlightTabs.length > 0) {
    spotlightTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        spotlightTabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        const target = tab.getAttribute('data-target');
        const selected = spotlightData[target];
        if (!selected) return;

        const animateElements = [
          '#value-standard', '#value-grainary',
          '#desc-standard', '#desc-grainary',
          '#tag-standard', '#tag-grainary',
          '#badge-standard', '#badge-grainary'
        ].filter(id => document.querySelector(id));

        const tl = gsap.timeline();
        if (animateElements.length > 0) {
          tl.to(animateElements, { opacity: 0, y: 6, duration: 0.18 });
        }

        tl.add(() => {
          const vStd = document.getElementById('value-standard');
          const vGrn = document.getElementById('value-grainary');
          const dStd = document.getElementById('desc-standard');
          const dGrn = document.getElementById('desc-grainary');
          const tStd = document.getElementById('tag-standard');
          const tGrn = document.getElementById('tag-grainary');
          const bStd = document.getElementById('badge-standard');
          const bGrn = document.getElementById('badge-grainary');

          if (vStd) vStd.innerText = selected.standard.val;
          if (vGrn) vGrn.innerText = selected.grainary.val;
          if (dStd) dStd.innerText = selected.standard.desc;
          if (dGrn) dGrn.innerText = selected.grainary.desc;
          if (tStd) tStd.innerText = selected.standard.tag;
          if (tGrn) tGrn.innerText = selected.grainary.tag;
          if (bStd) bStd.innerText = selected.standard.badge;
          if (bGrn) bGrn.innerText = selected.grainary.badge;
        });

        if (document.getElementById('visual-standard')) {
          tl.to('#visual-standard', { scale: 1.05, duration: 0.25, yoyo: true, repeat: 1, ease: 'power2.out' }, 'visual');
        }
        if (document.getElementById('visual-grainary')) {
          tl.to('#visual-grainary', { scale: 1.08, duration: 0.25, yoyo: true, repeat: 1, ease: 'back.out(2)' }, 'visual');
        }

        if (animateElements.length > 0) {
          tl.to(animateElements, { opacity: 1, y: 0, duration: 0.3, stagger: 0.03 });
        }
      });
    });
  }

  // 9. Community Reviews Auto-Scroll (Disabled in favor of native scroll)
  /*
  const reviewTrack = document.querySelector('.mockup-reviews__slider');
  if (reviewTrack) {
    const reviews = gsap.utils.toArray('.review-card');
    const totalWidth = reviewTrack.scrollWidth;
    
    // Auto-scroll loop
    gsap.to(reviewTrack, {
      x: () => `-=${totalWidth / 2}`, 
      ease: "none",
      duration: 40,
      repeat: -1
    });
  }
  */

});